import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalStateHelper } from '@helpers/GlobalStateHelper';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor( ) { }

  ngOnInit(): void { }

}
